//Global keys
let locales = {
    "parameters_menu": "Parametri",
};

//Merge Modules
import list from '../../views/list/lan/it'
import editCampaignFrom from '../../modals/editCampaignFrom/lan/it'
import editTemplate from '../../modals/editTemplate/lan/it'
import sendersList from '../../components/senders/lan/it'
import templateList from '../../components/templates/lan/it'

import parameterList from '../../views/list/components/parameters/lan/it'
import editParameter from '../../modals/editParameter/lan/it'
import agentConfigNotifications from '../../components/agentConfigNotifications/lan/it'
import editParametrizableText from '../../modals/editParametrizableText/.config/lan/it'
import parametrizableTexts from '../../components/parameterizableTexts/lan/it';
import configStatusLeads from '../../components/configStatusLeads/lan/it';
import editSatutsLeads from '../../modals/editSatutsLeads/lan/it';
import cronConfig from '../../components/cronConfig/lan/it';

locales = {
    ...locales,
    ...list,
    ...editCampaignFrom,
    ...editTemplate,
    ...sendersList,
    ...templateList,
    ...parameterList,
    ...editParameter,
    ...agentConfigNotifications,
    ...parametrizableTexts,
    ...editParametrizableText,
    ...configStatusLeads,
    ...editSatutsLeads,
    ...cronConfig,
};

export default locales;